module.exports = __webpack_public_path__ + "static/img/advice.7e11ec1.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/newWx/advice.png
// module id = p3Vy
// module chunks = 0